import { Loader } from "dash-styled"
import React, { FC } from "react"
import { AppDetailBase } from "../../AppDetailBase/AppDetailBase"
import { useNeqlContextProvider } from "../../../../../../../Hooks/useNeqlContextProvider"
import { metaAI } from "neql"
import { AITrainingStatus } from "./Common/AITrainingStatus"
import { TrainingPerformance } from "./Common/TrainingPerformance"
import { shouldStopRefreshingAIInstance } from "../../../../../../../Models/API/AIModel"
import { useInterval } from "../../../../../../../Hooks/useInterval"

export interface AITrainingDetailProps {
    orgUsername: string
    appID: string
    instanceID: string
}

/**
 * No longer used, kept for future reuse
 */
export const AITrainingDetail: FC<AITrainingDetailProps> = ({
    orgUsername,
    appID,
    instanceID
}) => {
    const client = useNeqlContextProvider("metaAIApp", appID)
    const { data: aiTrainingInstance, refetch: refetchInstance } =
        metaAI.useGetAiTrainingInstanceQuery({
            client,
            variables: { instanceId: instanceID }
        })
    useInterval(
        refetchInstance,
        5000,
        aiTrainingInstance?.meta_ai_training_instance_by_pk === undefined ||
            aiTrainingInstance?.meta_ai_training_instance_by_pk === null ||
            shouldStopRefreshingAIInstance(
                aiTrainingInstance.meta_ai_training_instance_by_pk
            )
    )
    const aiInstance = aiTrainingInstance?.meta_ai_training_instance_by_pk
    if (aiInstance === undefined) {
        return (
            <AppDetailBase
                orgUsername={orgUsername}
                id={appID}
                title={null}
                breadcrumbs={[]}
                fixedContentWidth={false}
            >
                <Loader />
            </AppDetailBase>
        )
    }

    return (
        <AppDetailBase
            orgUsername={orgUsername}
            id={appID}
            title={
                <div className="flex items-center gap-4 lg:gap-8">
                    <div className="flex-grow">
                        {aiInstance?.training_template?.name ?? ""} (source
                        version {aiInstance?.model.version ?? "-"})
                    </div>

                    <AITrainingStatus
                        className="text-sm font-normal"
                        trainingInstanceState={aiInstance?.state}
                    />
                </div>
            }
            breadcrumbs={["AI Models"]}
            fixedContentWidth={false}
        >
            <div className="my-8 grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6">
                {aiInstance?.metrics.map(metric => (
                    <TrainingPerformance
                        key={metric.metric_name}
                        aiMetric={metric}
                    />
                ))}
            </div>
        </AppDetailBase>
    )
}
